// Copy used by the boot intro, start menu and System Properties. Tweak freely.
export const PROFILE = {
  name: "Marcel",
  osName: "Marcel OS",
  tagline: "Developer · Designer · Tinkerer",
  visitorName: "Visitor",
  // Shown in System Properties > Contact. Leave a field empty to hide it;
  // the tab is hidden entirely while they're all empty.
  links: {
    email: "",
    github: "",
    linkedin: "",
    website: "",
  },
};
